import { render, staticRenderFns } from "./InTransit.vue?vue&type=template&id=53e8c3c0&scoped=true&"
import script from "./InTransit.vue?vue&type=script&lang=ts&"
export * from "./InTransit.vue?vue&type=script&lang=ts&"
import style0 from "./InTransit.vue?vue&type=style&index=0&id=53e8c3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8c3c0",
  null
  
)

component.options.__file = "InTransit.vue"
export default component.exports